import instance from "../config/axios";
import { base_apis } from "../config/url";

export const getProfile = () => {
    return instance.get(`${base_apis.user}/get-profile`)
        .then((res) => {
            return res;
        });
};

export const getEditProfile = () => {
    return instance.get(`${base_apis.user}/get-edit-profile`)
        .then((res) => {
            return res;
        });
};

export const updateEditProfile = (data) => {
    return instance.post(`${base_apis.user}/update/edit-profile`, data)
        .then((res) => {
            return res;
        });
};

export const getAvatarList = () => {
    return instance.post(`${base_apis.profile}/avatar/list`)
        .then((res) => {
            return res;
        });
};

export const getStats = () => {
    return instance.post(`${base_apis.stats}/list`)
        .then((res) => {
            return res;
        });
};

export const getLevel = () => {
    return instance.post(`${base_apis.level}/list`)
        .then((res) => {
            return res;
        });
};


export const getUserDetails = (id) => {
    return instance.get(`${base_apis.user}/get-user-profile/${id}`) // Use GET instead of POST for fetching details
        .then((res) => res);
};

export const getUserStateDetail = (id) => {
    return instance.post(`${base_apis.stats}/user-list/${id}`)
        .then((res) => {
            return res;
        });
};